var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFocus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_216_3037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2549 7.49995V2.24695C23.2549 1.84912 23.0968 1.46759 22.8155 1.18629C22.5342 0.904984 22.1527 0.746948 21.7549 0.746948H16.5049",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5049 23.247H21.7549C22.1527 23.247 22.5342 23.089 22.8155 22.8077C23.0968 22.5264 23.2549 22.1448 23.2549 21.747V16.5",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.754883 16.5V21.75C0.754883 22.1478 0.912918 22.5294 1.19422 22.8107C1.47553 23.092 1.85706 23.25 2.25488 23.25H7.50488",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50488 0.746948H2.25488C1.85706 0.746948 1.47553 0.904984 1.19422 1.18629C0.912918 1.46759 0.754883 1.84912 0.754883 2.24695V7.49995",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_216_3037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocus);
export default __webpack_public_path__ + "static/media/Focus.b8d3d5f51138a7d8fb0c5faad2c9fdbb.svg";
export { ForwardRef as ReactComponent };